import { CurrencyISOCode, PricingTierPrice } from "../constants";

export const getLocalUnitPrice = (
    currencyISOCode: CurrencyISOCode,
    prices: PricingTierPrice[]
) =>
    prices.find(({ currency }) => currency === currencyISOCode)?.unitPrice || 0;
